import React from 'react';
import Link from 'gatsby-link'
class SocialButton extends React.Component {
    static defaultProps = {
        target: "_blank"
    }
    constructor(props) {
        super(props);
    }
    handleClick() {
        window.open(this.props.link, "_blank");
    }
    render() {
        return (
            <a href={this.props.to} target={this.props.target} className="social-button">
                <i className={this.props.className} aria-hidden="true"></i>
            </a>
        );
    }
}

export default SocialButton;


// WEBPACK FOOTER //
// ./src/components/SocialButton/SocialButton.js